import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import { Image } from "cloudinary-react";

const Product = ({ product, lang, currency, menu }) => {
  const [textColor, setTextColor] = useState("text-primary");

  const handleMouseOver = () => setTextColor("");
  const handleOnMouseOut = () => setTextColor("text-primary");

  return (
    <Card className="m-2 rounded" style={{ border: "none" }}>
      <Link to={`/product/${product._id}/${menu}?`}>
        <Card style={{ border: "none" }}>
          <Image
            style={{ objectFit: "cover", border: "none" }}
            cloudName={"dljielsye"}
            publicId={product.image[0]}
            height={400}
            alt=""
          />
        </Card>
      </Link>
      <Card.Body>
        <Row>
          <Col>
            <Link
              to={`/product/${product._id}/${menu}?`}
              style={{ textDecoration: "none" }}
            >
              <Card.Title as="div" className="mr-2 d-flex align-items-center">
                <strong
                  className={textColor}
                  onMouseOver={handleMouseOver}
                  onMouseLeave={handleOnMouseOut}
                >
                  {product.productName}
                </strong>
              </Card.Title>
            </Link>
          </Col>

          <Col>
            <Card.Text
              as="h5"
              className="d-flex align-items-center justify-content-end"
            >
              <Row>
                <Col className="d-flex justify-content-end">
                  {/* {currency === "jpn" ? "¥" : "$"} */}
                  {/* {product?.price[currency]} */}${product?.price}
                </Col>
              </Row>
            </Card.Text>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Product;
